import type { BusinessProfileFields } from '@repo/api-contracts';
import type { ReactElement } from 'react';

export const TaxInvoiceBuyerDetails = ({
  request,
}: {
  readonly request: BusinessProfileFields;
}): ReactElement => (
  <details className="mt-4 text-sm">
    <summary className="cursor-pointer font-medium">사업자 정보</summary>
    <dl className="mt-2 space-y-1">
      <div>사업자등록번호: {request.businessNumber}</div>
      <div>상호: {request.companyName}</div>
      <div>대표자: {request.representativeName}</div>
      <div>주소: {request.address}</div>
      <div>업태: {request.businessType}</div>
      <div>종목: {request.businessItem}</div>
      <div>이메일: {request.invoiceEmail}</div>
      <div>담당자: {request.contactName ?? '-'}</div>
    </dl>
  </details>
);
